import type { ReactNode as Children } from 'react';
import { Box, Typography } from '@mui/material';
import React from 'react';

declare type Ink = 'default' | 'muted' | 'placeholder';

interface Props {
    title: Children | string;
    subtitle: Children | string;
    subtitleInk?: Ink;
    headerLink?: Children | string;
}

const PageHeader = ({ title, subtitle, subtitleInk, headerLink }: Props) => {
    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Typography variant="h3">{title}</Typography>
                <Box>{headerLink}</Box>
            </Box>
            <Box>
                <Typography
                    variant="body1"
                    color={
                        subtitleInk === 'default'
                            ? 'text.primary'
                            : 'text.secondary'
                    }
                    sx={{ '& > a': { fontSize: 'inherit' } }}
                >
                    {subtitle}
                </Typography>
            </Box>
        </Box>
    );
};

export default PageHeader;
